'use client';

interface SimulationControlsProps {
  onRunSimulation: () => void;
  onResetSimulation: () => void;
  simulationResults: any | null;
}

export default function SimulationControls({ onRunSimulation, onResetSimulation, simulationResults }: SimulationControlsProps) {
  return (
    <div className="bg-surface p-4 rounded-lg">
      <h3 className="font-bold text-foreground mb-4">Simulation</h3>
      <div className="flex items-center space-x-2 mb-4">
        <button
          onClick={onRunSimulation}
          className="px-4 py-2 bg-accent text-accent-foreground rounded-lg font-semibold hover:bg-accent-hover transition-colors"
        >
          Run Simulation
        </button>
        <button
          onClick={onResetSimulation}
          className="px-4 py-2 bg-background text-foreground rounded-lg hover:bg-background-dark transition-colors"
        >
          Reset
        </button>
      </div>
      {simulationResults && (
        <div>
          <h4 className="font-semibold text-foreground mb-2">Results</h4>
          <pre className="text-sm text-foreground/90 bg-background p-2 rounded-md">
            {JSON.stringify(simulationResults, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
